<template>
  <div>
    <template>
      <v-layout column align-center>
        <v-flex class="mt-5">
          <Avatar
            :username="`${nombrePerfil}`"
            :size="50"
            :rounded="true"
            color="#fff"
          >
          </Avatar>
        </v-flex>
      </v-layout>
    </template>
  </div>
</template>
<script>
import Avatar from 'vue-avatar';

export default {
  components: {
    Avatar,
  },
  data() {
    return {
      nombrePerfil: '',
    };
  },

  computed: {
    nombre() {
      return this.$store.state.usuario.nombre;
    },
  },

  created() {
    this.avatarLetter();
  },

  methods: {
    avatarLetter() {
      const me = this;
      const arrayNombre = me.nombre.split(' ');
      if (arrayNombre.length == 3) {
        arrayNombre.splice(2, 1);
        me.nombrePerfil = arrayNombre.join(' ');
      } else if (arrayNombre.length == 4) {
        arrayNombre.splice(1, 1);
        arrayNombre.splice(2, 1);
        me.nombrePerfil = arrayNombre.join(' ');
      } else {
        me.nombrePerfil = me.nombre;
      }
    },
  },
};
</script>
